import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'

import { Text, BlueText } from './DiscountStatusBanner.styles'
import { SmallPrint } from '../ReferralContent/ReferralContent.styles'

const messages = defineMessages({
  yourDiscount: {
    id: 'dashboard.referrals.yourDiscount',
    defaultMessage: 'Your referral discount'
  },
  monthlyDiscount: {
    id: 'dashboard.referrals.monthlyDiscount',
    defaultMessage: 'off your monthly subscription'
  },
  yearlyDiscount: {
    id: 'dashboard.referrals.yearlyDiscount',
    defaultMessage: 'off next years subscription'
  },
  trialDiscount: {
    id: 'dashboard.referrals.trialDiscount',
    defaultMessage: 'off your individual subscription'
  },
  smallPrintText: {
    id: 'dashboard.referrals.smallPrintText',
    defaultMessage:
      'Your status will update above as soon as your colleagues and friends register for a free trial on nightzookeeper.com.'
  },
  congratulations: {
    id: 'dashboard.referrals.congratulations',
    defaultMessage: 'Congratulations!'
  },
  freeMonthlyAccess: {
    id: 'dashboard.referrals.freeMonthlyAccess',
    defaultMessage:
      'You have referred 10 friends. Your account will be free for six months.'
  },
  freeYearAccess: {
    id: 'dashboard.referrals.freeYearAccess',
    defaultMessage: 'Your subscription next year is free.'
  },
  sixMonthAccess: {
    id: 'dashboard.referrals.sixMonthAccess',
    defaultMessage:
      'The above discount will be applied to your account for 6 months. Your status will update every time you refer a new friend.'
  }
})

export default class DiscountStatusBanner extends Component {
  static propTypes = {
    subscriptionType: PropTypes.string,
    discountPercentage: PropTypes.number,
    isSubscribed: PropTypes.bool
  }

  getCongratulationsMessage () {
    return this.props.subscriptionType === 'monthly' || !this.props.isSubscribed ? (
      <FormattedMessage {...messages.freeMonthlyAccess} />
    ) : (
      <FormattedMessage {...messages.freeYearAccess} />
    )
  }

  getSmallPrintMessage () {
    return this.props.subscriptionType === 'monthly' || !this.props.isSubscribed ? (
      <FormattedMessage {...messages.sixMonthAccess} />
    ) : (
      <FormattedMessage {...messages.smallPrintText} />
    )
  }

  getSubscriptionTypeMessage () {
    switch (this.props.subscriptionType) {
      case 'monthly':
        return <FormattedMessage {...messages.monthlyDiscount} />
      case 'yearly':
        return <FormattedMessage {...messages.yearlyDiscount} />
      default:
        return <FormattedMessage {...messages.trialDiscount} />
    }
  }

  render () {
    const { subscriptionType, discountPercentage } = this.props

    const displayDiscount = (discountPercentage && `${discountPercentage}%`) || '0%'
    const displayAsterisk = discountPercentage !== 100 && '*'

    return (
      <Fragment>
        <Text type='main'>
          <FormattedMessage {...messages.yourDiscount} />
          {displayAsterisk}
          &nbsp;=&nbsp;
          {discountPercentage === 100 ? (
            <BlueText>
              <FormattedMessage {...messages.congratulations} />
            </BlueText>
          ) : (
            <Fragment>
              <BlueText>{displayDiscount}</BlueText>
              &nbsp;
              {this.getSubscriptionTypeMessage()}
            </Fragment>
          )}
        </Text>
        {discountPercentage === 100 ? (
          <SmallPrint type='regularYellow'>
            {this.getCongratulationsMessage()}
          </SmallPrint>
        ) : (
          <SmallPrint type='regularBlue'>
            *
            {this.getSmallPrintMessage()}
          </SmallPrint>
        )}
      </Fragment>
    )
  }
}
